import { createFileRoute } from '@tanstack/react-router'
import { VaultPage } from '@/features/vault/VaultPage'

export const Route = createFileRoute('/_app/vault')({
  component: VaultPage,
})
